import { computed, makeObservable, observable } from 'mobx'
import { getCategories } from '../services/ApiService'
import PagedCollectionStore from '../utils/stores/PagedCollectionStore'

class CategoriesStore extends PagedCollectionStore {
  constructor() {
    super({
      action: getCategories,
    })
    this.categoriesMenuData = []
    makeObservable(this, {
      categoriesMenuData: observable,
      categoryNames: computed,
    })
  }

  postLoad() {
    this.setCategoriesMenuData()
    super.postLoad()
  }

  get categoryNames() {
    return this.collection.map((el) => el.name)
  }

  getInputCategories = (categories) => {
    const result = []
    for (let i = 0; i < categories.length; i++) {
      if (categories[i]) {
        result.push(i)
      }
    }
    return result
  }

  unFormatCategories = (categories) => {
    const categoriesArr = categories?.split(', ')
    const result = []

    for (let i = 0; i < this.collection.length; i++) {
      if (categoriesArr?.includes(this.collection[i]?.name)) {
        result.push(true)
      } else {
        result.push(false)
      }
    }

    if (!result.includes(true)) {
      result[result.length - 1] = true
    }

    return result
  }

  getCategoryName = (id) => {
    const category = this.collection.find((el) => el.id === id)
    return category ? category.name : ''
  }

  formatCategory = (categories) => {
    return categories
      ?.map((el, i) => (el ? this.categoryNames[i] : el))
      .filter((el) => !!el)
      .join(', ')
  }

  getIndexesOfMatchingElements = (categories) => {
    const indexes = []
    this.categoryNames.forEach((item, index) => {
      if (categories.includes(item)) {
        indexes.push(index)
      }
    })
    return indexes
  }

  setCategoriesMenuData = () => {
    this.categoriesMenuData = this.collection.map((preferentialCategory) => {
      return { key: preferentialCategory.name, value: preferentialCategory.id }
    })
  }
}

export default CategoriesStore
